import { useMemo, useState } from "react";
import { Topbar } from "../components/Topbar";
import { Input } from "../components/ui/input";
import { CONTACTS, PROPERTIES } from "../data/mockData";
import { Mail, Phone, Search, Building2 } from "lucide-react";

export default function Contacts() {
  const [q, setQ] = useState("");
  const filtered = useMemo(
    () =>
      CONTACTS.filter(
        (c) =>
          !q ||
          c.name.toLowerCase().includes(q.toLowerCase()) ||
          c.company.toLowerCase().includes(q.toLowerCase()) ||
          c.role.toLowerCase().includes(q.toLowerCase())
      ),
    [q]
  );

  return (
    <>
      <Topbar
        title="Contacts"
        subtitle="Authorities, brokers, and internal operators linked to properties"
      />
      <div className="px-6 lg:px-8 py-8 space-y-6">
        <div className="flex items-center gap-2 rounded-sm border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-1.5 max-w-md">
          <Search size={14} className="text-slate-400" />
          <input
            data-testid="contacts-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search by name, role or company"
            className="bg-transparent outline-none text-sm py-1 w-full text-slate-800 dark:text-slate-200 placeholder:text-slate-400"
          />
        </div>

        <div className="rounded-md border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="contacts-table">
              <thead>
                <tr className="bg-slate-50 dark:bg-slate-800/40 text-[11px] font-semibold uppercase tracking-widest text-slate-500 dark:text-slate-400">
                  <th className="py-3 px-6 text-left">Contact</th>
                  <th className="py-3 px-4 text-left">Role</th>
                  <th className="py-3 px-4 text-left">Company</th>
                  <th className="py-3 px-4 text-left">Email</th>
                  <th className="py-3 px-4 text-left">Phone</th>
                  <th className="py-3 px-4 text-left">Linked properties</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((c) => (
                  <tr
                    key={c.id}
                    data-testid={`contact-row-${c.id}`}
                    className="border-t border-slate-200 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors"
                  >
                    <td className="py-3 px-6">
                      <div className="flex items-center gap-3">
                        <div className="h-8 w-8 rounded-sm bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 flex items-center justify-center text-xs font-semibold">
                          {c.name
                            .split(" ")
                            .map((s) => s[0])
                            .slice(0, 2)
                            .join("")}
                        </div>
                        <span className="text-slate-900 dark:text-slate-100 font-medium">
                          {c.name}
                        </span>
                      </div>
                    </td>
                    <td className="py-3 px-4 text-slate-700 dark:text-slate-300">{c.role}</td>
                    <td className="py-3 px-4 text-slate-700 dark:text-slate-300">{c.company}</td>
                    <td className="py-3 px-4 text-slate-700 dark:text-slate-300">
                      <span className="inline-flex items-center gap-1.5">
                        <Mail size={13} className="text-slate-400" /> {c.email}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-slate-700 dark:text-slate-300">
                      <span className="inline-flex items-center gap-1.5">
                        <Phone size={13} className="text-slate-400" /> {c.phone}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex flex-wrap gap-1">
                        {c.linkedPropertyIds.map((pid) => {
                          const p = PROPERTIES.find((x) => x.id === pid);
                          return (
                            <span
                              key={pid}
                              className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700"
                            >
                              <Building2 size={10} /> {p?.name}
                            </span>
                          );
                        })}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
